import * as React from 'react'
import PropTypes from 'prop-types'

const StockMessage = ({ stockMessage }) =>
  Array.isArray(stockMessage) ? (
    stockMessage?.map(stockItem => (
      <stockItem.Component id="stock-message" className="stock-message" key={stockItem.message}>
        {stockItem?.message}
      </stockItem.Component>
    ))
  ) : (
    <div id="stock-message" className="stock-message" dangerouslySetInnerHTML={{ __html: stockMessage }} />
  )

StockMessage.propTypes = {
  stockMessage: PropTypes.any.isRequired,
}

export default StockMessage
